import { ReactNode, useContext } from "react";
import { HostPortalContext } from "@/contexts/portalBranding";
import { UnknownBrandPage } from "@/pages/portal/UnknownBrandPage";

/**
 * Stops an unclaimed `<slug>.reveshare.com` from rendering the marketplace.
 *
 * Sits above the router on purpose: the address is wrong, not the route, so no
 * path under it should resolve. While the hostname is still being looked up it
 * renders nothing rather than the app — a brief blank beats flashing the
 * Reveshare shell on a brand's address.
 */
export function PortalHostGate({ children }: { children: ReactNode }) {
  const { isLoading, isUnknownPortal } = useContext(HostPortalContext);

  if (isLoading) return null;
  if (isUnknownPortal) return <UnknownBrandPage />;
  return <>{children}</>;
}
